exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-notes-index-jsx": () => import("./../../../src/pages/notes/index.jsx" /* webpackChunkName: "component---src-pages-notes-index-jsx" */),
  "component---src-pages-notes-markdown-remark-frontmatter-slug-jsx": () => import("./../../../src/pages/notes/{markdownRemark.frontmatter__slug}.jsx" /* webpackChunkName: "component---src-pages-notes-markdown-remark-frontmatter-slug-jsx" */)
}

